import React from "react";
import CommonButtons from "src/shared/components/CommonButtons";
interface ImportButtonProps {
  inputRef: React.RefObject<HTMLInputElement>;
  handleImport: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ImportButton: React.FC<ImportButtonProps> = ({ inputRef, handleImport }) => (
  <div className="import-area w-24 cursor-pointer">
    <CommonButtons label="IMPORT" onClick={() => inputRef.current?.click()} />
    <input ref={inputRef} type="file" style={{ display: "none" }} onChange={handleImport} />
  </div>
);

export default ImportButton;
